import React, { FC } from "react";
import { Button, Table, Upload, Tooltip } from "antd";
import { YhBox } from "@/components/YhBox";
import { globalPrompt } from "@/components/message";
import { ColumnsType } from "antd/es/table";
import { useSaleOrderDetailModel } from "./saleOrderDetailModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { DetailType } from "@/types/ScmEnums";
import { IDetailList } from "../../saleOrderTypes";
import { formatInt, formatIntPoint, formatNum } from "@/utils/utils";
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import { importPropsConfig } from "@/utils/importFile";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";


export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const { setAddModalVisible,
        detailDataSource,
        detailLookList,
        detailAddList,
        detaiAddDataRowKeys,
        detailDataRowKeys,
        detailDataRow,
        onExport,
        setDetailDataRow,
        setDetailAddList,
        setDetailDataRowKeys,
        setDetailDataSource,
        setDetaiAddDataRowKeys,
        setDetaiAddDataRow,
        detailDetailList,
        modelScreenMethod,
        setMaterialHistoryRow,
        setMaterialHistoryModel
    } = useSaleOrderDetailModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const importCallback = async (list: any) => {
        console.log(list)
        if (mode == "add") {
            const { repetition, newDetailData } = await modelScreenMethod(list, detailAddList, mode)
            setDetailAddList([...detailAddList, ...newDetailData])
            // repetition.length != 0 && globalPrompt("message", { text: `物料名称：${repetition.join(",")}，重复的将不在添加。`, type: "warning" });
            repetition.length != 0 && globalPrompt("message", { text: `${Locale["The material name of"]}${repetition.join(",")}${Locale["is repeated and will not be added."]}`, type: "warning" });

        } else if (mode == "edit") {
            const { repetition, newDetailData } = await modelScreenMethod(list, detailDataSource, mode)
            setDetailDataSource([...detailDataSource, ...newDetailData])
            // repetition.length != 0 && globalPrompt("message", { text: `物料名称：${repetition.join(",")}，重复的将不在添加。`, type: "warning" });
            repetition.length != 0 && globalPrompt("message", { text: `${Locale["The material name of"]}${repetition.join(",")}${Locale["is repeated and will not be added."]}`, type: "warning" });

        }
    }
    const action = mode == "look" ? <></> : <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => setAddModalVisible(true)}
        >{Locale["Add Material"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { detailDetailList(mode) }}
        >{Locale["Delete Material"]}</Button>
        <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/vrm-sa/sale/details/import`, importCallback)}>
            <Button className="mr-5" type="link" shape="round">{Locale["Import Details"]}</Button>
        </Upload>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { onExport() }}
        >{Locale["Download template"]}</Button>
    </>;
    const setHistoryDetail = (record: any) => {
        setMaterialHistoryRow(record)
        setMaterialHistoryModel(true)
    }
    const columns = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            // title: '商品编码',
            title: Locale["Material Code"],
            width: 150,
            dataIndex: 'materialCode',
            render: (text: any, record: any) => <Tooltip placement="topLeft" title={text}><p onClick={() => setHistoryDetail(record)} className="ellipsis click-span">{text}</p></Tooltip>,

        }, {
            // title: '商品名称',
            title: Locale["Material Name"],
            width: 150,
            dataIndex: 'materialName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品名称-英文',
            title: Locale['Material Name En'],
            width: 160,
            dataIndex: 'materialNameEn',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '数量',
            title: Locale["Qty"],
            width: 150,
            dataIndex: 'num',
            editable: mode != "look" ? true : false,
        }, {
            // title: '单价',
            title: Locale["Unit Price"],
            width: 150,
            dataIndex: 'price',
            editable: mode != "look" ? true : false,
        }, {
            // title: '金额',
            title: Locale["Amount"],
            width: 150,
            dataIndex: 'notAmount',
        }, {
            // title: '折扣',
            title: Locale["Discount Rate"],
            width: 120,
            dataIndex: 'discountRate',
            editable: mode != "look" ? true : false,
            suffix: "%",
            render: (text: string) => text + '%'
        }, {
            // title: '折后单价',
            title: Locale["Discounted Price"],
            width: 120,
            dataIndex: 'taxPrice',
        }, {
            // title: '总计',
            title: Locale["Total"],
            width: 150,
            dataIndex: 'amount',
        }, {
            // title: '仓库',
            title: Locale["Warehouse"],
            width: 150,
            dataIndex: 'warehouseName',
        }, {
            // title: '货位',
            title: Locale["Shelf"],
            width: 150,
            dataIndex: 'shelfCode',
        }, {
            // title: '库存',
            title: Locale["Inventory"],
            width: 150,
            dataIndex: 'inventoryNum',
        }, {
            // title: '备注',
            title: Locale["Note"],
            width: 150,
            dataIndex: 'note',
        }
    ];
    const newSelectColumns = () =>
        columns.map((col, index) => {
            return {
                ...col,
                onCell: (record: IDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    // rules: col.rules,
                    // options: col.options,
                    // editType: col.editType,
                    suffix: col.suffix,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave,
                }),
            }
        })
    const handleSave = (row: IDetailList) => {
        let { num, price, discountRate, inventoryNum } = row
        num = +formatIntPoint(num);
        price = +formatIntPoint(price);
        discountRate = +formatIntPoint(discountRate);
        inventoryNum = +formatIntPoint(inventoryNum);

        let newRow = {
            ...row,
            discountRate,
            price,
            taxPrice: formatNum(price * discountRate / 100),
            num: +formatIntPoint(num, inventoryNum, "销售数量≥库存数量"),
            notAmount: +formatNum(num > inventoryNum ? 0 : num * price),
            amount: +formatNum(num > inventoryNum ? 0 : num * price * (discountRate / 100))
        }
        let newData = mode == "edit" ? detailDataSource : detailAddList;
        const index = newData.findIndex((item) => row.detailsId === item.detailsId);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...newRow });
        mode == "edit" ? setDetailDataSource([...newData]) : setDetailAddList([...newData])
    }
    const typeList = {
        "add": [...detailAddList],
        "edit": [...detailDataSource],
        "look": [...detailLookList],
    }
    const setTypeDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode == DetailType.add) {
            setDetaiAddDataRowKeys(selectedRowKeys)
        } else if (mode == DetailType.edit) {
            setDetailDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeDetailDataRow = async (selectedRows: IDetailList[], mode: string) => {
        if (mode == DetailType.add) {
            setDetaiAddDataRow(selectedRows)
        } else if (mode == DetailType.edit) {
            setDetailDataRow(selectedRows)
        }
    }
    return (
        <YhBox title={Locale["Sales Details"]} rightChildren={action} style={{ marginBottom: "75px" }}>
            <Table
                rowKey={record => record.detailsId as string}
                rowClassName='editable-row yh-edit-table-tr'
                rowSelection={
                    mode == DetailType.look ? undefined : {
                        selectedRowKeys: mode == DetailType.add ? detaiAddDataRowKeys : detailDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IDetailList[]) => {
                            setTypeDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeDetailDataRow(selectedRows, mode)
                        }
                    }}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newSelectColumns() as ColumnsType<IDetailList>}
                dataSource={typeList[mode] as IDetailList[]}
                pagination={false}
                onRow={record => ({
                    onClick: () => { }
                })}
                scroll={{ x: 'max-content', y: 290 }}
            />
        </YhBox>
    )
}